import React from "react";
import "../../App.css";

const ListItemContainer = ({
  index,
  onClick,
  extraClassName,
  children,
}: {
  index: number;
  onClick?: (v?: any) => void;
  children: JSX.Element | JSX.Element[];
  extraClassName?: string;
}): JSX.Element => {
  let className = index % 2 !== 0 ? "projects-itembar" : "projects-itembar-colored";

  if (extraClassName) {
    className = className + " " + extraClassName;
  }
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        justifyContent: "center",
      }}
    >
      <div
        className={className}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
        onClick={onClick}
      >
        {children}
      </div>
    </div>
  );
};

export default ListItemContainer;
